import { render, staticRenderFns } from "./ManageRequestTypes.vue?vue&type=template&id=38ca47ef"
import script from "./ManageRequestTypes.vue?vue&type=script&lang=js"
export * from "./ManageRequestTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports